import { Link } from 'react-router-dom'

export function Logo({
  onNavigate,
  compact = false,
}: {
  onNavigate?: () => void
  compact?: boolean
}) {
  return (
    <Link
      className={`brand ${compact ? 'brand-compact' : 'brand-lockup'}`}
      to="/"
      aria-label="Square & Compass Notary home"
      onClick={onNavigate}
    >
      {compact ? (
        <>
          <img
            src="/images/brand/square-compass-notary-mark.webp"
            width="480"
            height="480"
            alt=""
          />
          <span className="brand-words">
            <strong>Square &amp; Compass Notary</strong>
            <small>Mobile notary &amp; document services</small>
          </span>
        </>
      ) : (
        <img
          src="/images/brand/square-compass-notary-lockup.webp"
          width="1200"
          height="380"
          alt=""
        />
      )}
    </Link>
  )
}
